export default "__VITE_ASSET__DeAWkwg6__"